(function () {
    'use strict';

    angular
        .module('sodCommon')
        .factory('MainService', MainService);

    function MainService(Action, Path, ButtonRegistry, NotificationService, lodash, $rootScope, $anchorScroll, $location, $http, ActionModel, DialogManager) {
        return function($scope) {
            $scope.currentEvents = {};

            return {
                getStructure: getStructure,
                addViewEvents: addViewEvents,
                clearViewEvents: clearViewEvents,
                removeViewEvents: removeViewEvents,
                setViewEvents: setViewEvents
            };

            /**
             * Function to get structure+content of the current path
             * @param path
             * @returns promise of the $http.get
             */
            function getStructure (oldPath) {
                Path.change();
                // SODO: Write a decorator to override/add function to get portal structure path, otherwise, have structurepath accept third variable to control
                var structurePath = Path.getStructurePath();
                destroyEvent();

                var data = Path.getPathInfo().search();
                if (oldPath) {
                    data.oldPath = oldPath.viewPath();
                }

	              // ActionModel.clearAll();
                ButtonRegistry.reset();
                DialogManager.destroyAll();
                return $http.get(structurePath, {params:data})
                    .then(function (res, status) {
                        //SodLogger.pageChange();
                        // success
                        if (status == 302) {
                            // Todo: Handle redirection
                            $location.path('/');
                        }

                        // Only load pathStructure data and events only if the current path matches.
                        // The fix tries to prevent situation where users clicked 2 or more links simultaneously
                        // And load only the structure information of the current path according to the url in the browser
                        // Unsure of any side effects at the time of writing this fix.
                        if (structurePath == Path.getStructurePath()) {
                            $scope.error = !res.data.success;
                            NotificationService.set({});

                            if (res.data.success) {
                                $scope.content = res.data.structure;
                                $rootScope.title = $scope.content.title;
                            } else {
                                if (lodash.has(res, 'data.structure')) {
                                    $scope.content = res.data.structure;
                                }
                                $rootScope.title = lodash.get(res.data, 'structure.display_title', res.data.status_code);
                            }

                            if (lodash.has(res, 'data.actions')) {
                                Action.run('', res.data.actions, $scope.content, {}, $scope);
                            }
                            initEvent();
                            //$scope.getNavBar();
                            $anchorScroll();
                            if (angular.element('.preloader-wrapper')) {
                                angular.element('.preloader-wrapper').remove();
                                angular.element('.main-app-wrapper').css('display','block');
                            }
                        }
                    }, function () {
                        // error
                    });
            }

            function initEvent() {
                angular.forEach($scope.content.view_events, function (evt, evtName) {
                    $scope.currentEvents[evtName] = $scope.$on(evtName, function (e, customEventData) {
                        // console.log('%cEventTriggered: ' + evtName, 'color: #e67e22');
                        // item refers to the element that activates the event
                        Action.run(evtName, evt, $scope.content, customEventData, $scope);
                    });
                });

                // $scope.currentEvents.push($scope.$on('action.common.button.cancel', function () {
                //     Path.redirect(Path.up());
                // }));
                $scope.currentEvents['validate.file'] = $scope.$on('validate.file', function (e, eventData) {
                    Action.run('', eventData.rules, $scope.content, eventData, $scope);
                    $scope.$digest();
                });
                // an event used to check scope
                //$scope.currentEvents.push($scope.$on('action.debug', function () {
                //
                //}));
            }

            function addViewEvents(view_events) {
                angular.forEach(view_events, function(actions, evtName) {
                    if (lodash.has($scope.currentEvents, evtName)) {
                        $scope.currentEvents[evtName]();
                        lodash.unset(vm.eventRegistrationMap, evtName);
                    }

                    $scope.currentEvents[evtName] = $scope.$on(evtName, function (e, eventData) {
                        Action.run(evtName, eventData.rules, $scope.content, eventData, $scope);
                    });
                });
            }

            function setViewEvents(view_events) {
                destroyEvent();
                addViewEvents(view_events);
            }

            function removeViewEvents(view_events) {
                angular.forEach(view_events, function(evtName) {
                    if (lodash.has($scope.currentEvents, evtName)) {
                        $scope.currentEvents[evtName]();
                        lodash.unset($scope.currentEvents, evtName);
                    }
                });
            }

            function clearViewEvents() {
                destroyEvent();
            }

            function destroyEvent() {
                // important to destroy events, preventing memory leak
                angular.forEach($scope.currentEvents, function (evtDeregistration) {
                    evtDeregistration();
                });
                $scope.currentEvents = {};
                //angular.element($window).unbind('beforeunload', handleWindowClose);
            }


        };
    }
})();